/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function VCioServices() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            Core vCIO Services
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            High-level IT expertise that strengthens your technology, reduces risk,
            and aligns your systems with your long-term goals.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Strategic IT Planning
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Technology roadmaps, modernization plans, and long-term IT strategies built around your vision.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                IT Budgeting & Forecasting
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Predictable planning for hardware, software, cloud services, cybersecurity, and growth.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Cybersecurity Oversight
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Risk assessments, compliance guidance, and security frameworks that protect your business.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Choose a vCIO?"
        subtitle="Executive-level guidance ensures your technology decisions support growth and reduce risk."
        benefits={[
          {
            id: "executive-expertise",
            title: "Executive-Level IT Expertise",
            text: "All the strategic leadership of a CIO at a fraction of the cost.",
            delay: 0,
          },
          {
            id: "stability",
            title: "Long-Term Technology Stability",
            text: "Plan for growth, minimize risk, and modernize your IT environment.",
            delay: 120,
          },
          {
            id: "efficiency",
            title: "Improved Business Efficiency",
            text: "Use technology to increase productivity and reduce operational bottlenecks.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "leadership", text: "Structured IT leadership" },
          { id: "planning", text: "Better long-term planning" },
          { id: "risk", text: "Reduced risk & stronger security" },
          { id: "alignment", text: "Aligned IT & business goals" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Need Leadership That Understands Your Technology?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let a dedicated vCIO guide your IT decisions with strategy and clarity.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
